import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Button } from "react-bootstrap";
import LicensesList from "../Components/LicensesList";
import Core from "../Core";
import ButtonBack from "../Components/ButtonBack";

class LicensesListPage extends Component {
    getCurrentCustomer() {
        const { stores, customerId } = this.props;
        const customer = stores.data.CustomersStore.findById(customerId);
        return customer;
    }

    onAddClicked() {
        const { stores } = this.props;

        const customer = this.getCurrentCustomer();
        if (customer) {
            let newLicense = stores.data.LicensesStore.add();
            newLicense.CustomerId = customer.Id;

            const hash = `#license-detail?id=` + newLicense.Id;
            window.location.hash = hash;
        }
    }
    onMakeOfflineAvailableClicked() {
        const { customerId } = this.props;
        window.location.hash = `#offline-licenses-in-use-list?customerId=${customerId}`;
    }

    render() {
        const { stores } = this.props;

        const customer = this.getCurrentCustomer();
        let customerName = "";
        if (customer) customerName = customer.Name;

        // Admin buttons
        let addButton = null;
        if (stores.currentUser.user.isAdmin) {
            addButton = <Core.Components.Buttons.Add onClick={this.onAddClicked.bind(this)} />;
        }

        return (
            <div>
                <div className="row">
                    <ButtonBack />
                </div>

                <div className="row">
                    <h1>Licences for {customerName}</h1>
                </div>

                <div className="row">
                    <div className="pull-right">{addButton}</div>
                </div>

                <div className="row">
                    <LicensesList licensesStore={stores.data.LicensesStore} stores={stores} />
                </div>

                <div className="row">
                    <Button bsStyle="link" onClick={this.onMakeOfflineAvailableClicked.bind(this)}>
                        Make offline available
                    </Button>
                </div>
            </div>
        );
    }
}

export default inject("stores")(observer(LicensesListPage));



// WEBPACK FOOTER //
// ./src/Pages/LicensesListPage.js